import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
} from '@atlassian/ufo-experimental/experience-types';
import { UFOExperience } from '@atlassian/ufo-experimental/experience';

const DEFINITIONS_COMPONENT = 'search-ai-definitions';

export const aiDefinitionsLoadUFOExperience: UFOExperience = new UFOExperience(
	`${DEFINITIONS_COMPONENT}-load`,
	{
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
		platform: { component: DEFINITIONS_COMPONENT },
	},
);
